
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexieOK_45Lknn6xiH3udDFjv1QqgdX2eYUhZ7rVSKQtdaSgMeta } from "/tmp/tmpgl07msmh/pages/index.vue?macro=true";
import { default as index2JJp_45M1FWCw9jlkgf_451o4xoLp6_45H3cmjG75R1xJvGXUMeta } from "/tmp/tmpgl07msmh/pages/[area]/index.vue?macro=true";
import { default as index7lm4SwXSHdkooOBwj2J9EDjtrGp_aHa1HV5HavMSOLgMeta } from "/tmp/tmpgl07msmh/pages/okinawa/index.vue?macro=true";
import { default as indexFkyjcIOs5V8opsf3bf_cL_45LqasPoWaPuc9ZYaOV0jmMMeta } from "/tmp/tmpgl07msmh/pages/ranking/index.vue?macro=true";
import { default as indexNyzdBI_j8Q1F0eJs_UXgC3SnUPQGG_457QHzeMIpdZjr4Meta } from "/tmp/tmpgl07msmh/pages/okinawa/[id]/index.vue?macro=true";
import { default as indexJdYd7xJIvDEFJCtV_h4ZqzR7JSlabDPUtwGrV31ODfUMeta } from "/tmp/tmpgl07msmh/pages/[area]/[pref]/index.vue?macro=true";
import { default as index8JDTeyDAJ8sS6isi043Yyxh_eZV5M0EpOLEJQmXX8DoMeta } from "/tmp/tmpgl07msmh/pages/ranking/[area]/index.vue?macro=true";
import { default as index724U3cbszF0E9w7A3o8nOrP_lLZT4Yqy1Lq5Kea0qycMeta } from "/tmp/tmpgl07msmh/pages/[area]/[pref]/[id]/index.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/tmp/tmpgl07msmh/pages/index.vue")
  },
  {
    name: "area",
    path: "/:area()",
    component: () => import("/tmp/tmpgl07msmh/pages/[area]/index.vue")
  },
  {
    name: "okinawa",
    path: "/okinawa",
    component: () => import("/tmp/tmpgl07msmh/pages/okinawa/index.vue")
  },
  {
    name: "ranking",
    path: "/ranking",
    component: () => import("/tmp/tmpgl07msmh/pages/ranking/index.vue")
  },
  {
    name: "okinawa-id",
    path: "/okinawa/:id()",
    component: () => import("/tmp/tmpgl07msmh/pages/okinawa/[id]/index.vue")
  },
  {
    name: "area-pref",
    path: "/:area()/:pref()",
    component: () => import("/tmp/tmpgl07msmh/pages/[area]/[pref]/index.vue")
  },
  {
    name: "ranking-area",
    path: "/ranking/:area()",
    component: () => import("/tmp/tmpgl07msmh/pages/ranking/[area]/index.vue")
  },
  {
    name: "area-pref-id",
    path: "/:area()/:pref()/:id()",
    component: () => import("/tmp/tmpgl07msmh/pages/[area]/[pref]/[id]/index.vue")
  }
]